import { useMutation, gql } from '@apollo/client';

import { GET_PAGINATED_WORKING_CONDITIONS } from './get-paginated-working-conditions.hook';

export const UPDATE_ACTIVE_WORKING_CONDITION = gql`
  mutation updateActiveWorkingCondition(
    $workingConditionId: ObjectId!
    $payload: UpdateActiveWorkingConditionInput!
  ) {
    updateActiveWorkingCondition(workingConditionId: $workingConditionId, payload: $payload) {
      _id
    }
  }
`;

export const useUpdateActiveWorkingCondition = ({ onSuccess }: { onSuccess: () => void }) => {
  const [updateActiveWorkingCondition] = useMutation(UPDATE_ACTIVE_WORKING_CONDITION, {
    onCompleted: data => {
      if (data) {
        onSuccess();
      }
    },
    refetchQueries: [GET_PAGINATED_WORKING_CONDITIONS],
  });

  return updateActiveWorkingCondition;
};
